<template>
  <LayoutTriggerCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    @delete="onDeleteClick"
    @configure="onConfigureClick"
  >
    <template #icon>
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5446 11C15.2943 11 15.9541 10.59 16.2939 9.97L19.8726 3.48C20.2425 2.82 19.7627 2 19.0029 2H4.20844L3.26879 0H0V2H1.99926L5.59792 9.59L4.24842 12.03C3.51869 13.37 4.47834 15 5.99777 15H17.9933V13H5.99777L7.09736 11H14.5446ZM5.15808 4H17.3036L14.5446 9H7.5272L5.15808 4ZM5.99777 16C4.89818 16 4.00851 16.9 4.00851 18C4.00851 19.1 4.89818 20 5.99777 20C7.09736 20 7.99703 19.1 7.99703 18C7.99703 16.9 7.09736 16 5.99777 16ZM15.9941 16C14.8945 16 14.0048 16.9 14.0048 18C14.0048 19.1 14.8945 20 15.9941 20C17.0937 20 17.9933 19.1 17.9933 18C17.9933 16.9 17.0937 16 15.9941 16Z" fill="#FFFFFF"/>
      </svg>
    </template>

    <template #content>
      <!-- Not Configured State -->
      <div v-if="!isConfigured" class="trigger-notification">
        <!-- <div class="trigger-notification-icon">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.70235 16.4156C1.31639 17.0823 1.79745 17.9167 2.56778 17.9167H17.4322C18.2025 17.9167 18.6836 17.0823 18.2976 16.4156L10.8654 3.57816C10.4803 2.91288 9.51974 2.91288 9.13457 3.57816L1.70235 16.4156ZM10.8333 14.5833C10.8333 15.0436 10.4602 15.4167 10 15.4167C9.53976 15.4167 9.16667 15.0436 9.16667 14.5833C9.16667 14.1231 9.53976 13.75 10 13.75C10.4602 13.75 10.8333 14.1231 10.8333 14.5833ZM10.8333 11.25C10.8333 11.7102 10.4602 12.0833 10 12.0833C9.53976 12.0833 9.16667 11.7102 9.16667 11.25V9.58333C9.16667 9.1231 9.53976 8.75 10 8.75C10.4602 8.75 10.8333 9.1231 10.8333 9.58333V11.25Z" fill="#D10000"/>
          </svg>
        </div>
        <div class="trigger-notification-text">No event selected.</div> -->
      </div>
      <!-- Configured State -->
      <div v-else class="trigger-configured-content">
        <div class="configured-message">
          <div class="configured-message-icon">
            <svg viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 0H1.66667C0.75 0 0 0.75 0 1.66667V4.16667H1.66667V1.66667H15V4.16667H16.6667V1.66667C16.6667 0.75 15.9167 0 15 0Z" fill="#374957"/>
              <path d="M15 11.6667H1.66667V9.16667H0V11.6667C0 12.5833 0.75 13.3333 1.66667 13.3333H15C15.9167 13.3333 16.6667 12.5833 16.6667 11.6667V9.16667H15V11.6667Z" fill="#374957"/>
              <path d="M10.7417 2.95833C10.4583 2.39167 9.53333 2.39167 9.25 2.95833L6.66667 8.13333L5.74167 6.29167C5.6 6.00833 5.31667 5.83333 5 5.83333H0V7.5H4.48333L5.91667 10.375C6.06667 10.6583 6.35 10.8333 6.66667 10.8333C6.98333 10.8333 7.26667 10.6583 7.40833 10.375L10 5.2L10.925 7.04167C11.0667 7.325 11.35 7.5 11.6667 7.5H16.6667V5.83333H12.1833L10.7417 2.95833Z" fill="#374957"/>
            </svg>
          </div>
          <div class="configured-message-text">Monitoring {{ monitoredEventsCount }} event:</div>
        </div>

        <div class="chips">
          <div class="chips-row">
            <div v-for="chip in visibleChipsRow1" :key="chip" class="chip">{{ chip }}</div>
          </div>
          <div class="chips-row">
            <div v-for="chip in visibleChipsRow2" :key="chip" class="chip">{{ chip }}</div>
            <div v-if="extraChipCount > 0" class="chip-more">+{{ extraChipCount }} more</div>
          </div>
        </div>
              </div>
    </template>
  </LayoutTriggerCard>
</template>

<script>
import LayoutTriggerCard from './LayoutTriggerCard.vue';

export default {
  name: 'StatusUpdateTrigger',
  components: {
    LayoutTriggerCard
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subtype() {
      return this.data?.subtype || 'order_update';
    },
    title() {
      const titleMap = {
        'order_update': 'Order Status Update',
        'appointment_update': 'Appointment Status Update',
        'document_update': 'Document/Form Status Update',
        'report_update': 'Report Status Update',
        'task_update': 'Task Status Update',
        'internal_notes_update': 'Internal Note Status Update',
        'new_patient_created': 'New Patient Created'
      };
      return titleMap[this.subtype] || 'Status Update';
    },
    subtitle() {
      const subtitleMap = {
        'order_update': 'Triggered when an order status changes',
        'appointment_update': 'Triggered when an appointment status changes',
        'document_update': 'Triggered when a document or form status changes',
        'report_update': 'Triggered when a report status changes',
        'task_update': 'Triggered when a task status changes',
        'internal_notes_update': 'Triggered when an internal note is updated',
        'new_patient_created': 'Triggered when a new patient is created'
      };
      return subtitleMap[this.subtype] || 'Triggered by status changes';
    },
    displayData() {
      return (this.data && this.data.savedData) ? this.data.savedData : this.data;
    },
    isConfigured() {
      return Boolean(this.displayData && this.displayData.configured);
    },
    isConfigureActive() {
      return Boolean(this.data && this.data.configureActive);
    },
    monitoredEventsCount() {
      const events = this.displayData && Array.isArray(this.displayData.events) ? this.displayData.events : [];
      return events.length;
    },
    events() {
      console.log(this.data);
      const events = this.data && Array.isArray(this.data.events) ? this.data.events : null;
      if (events) return events;
      return this.getDefaultEvents();
    },
    visibleChipsRow1() {
      return this.events.slice(0, 2);
    },
    visibleChipsRow2() {
      return this.events.slice(2, 4);
    },
    extraChipCount() {
      return Math.max(0, this.events.length - 4);
    }
  },
  methods: {
    getDefaultEvents() {
      const defaultEventsMap = {
        'Order Update': [
          'Order Created',
          'Order Modified',
          'Order Redrawn',
          'Payment Complete',
          'Payment Failed',
          'Payment Refund',
          'Lab Shipped',
          'Test Not Performed',
          'Order Canceled'
        ],
        'Appointment Update': [
          'Appointment Created',
          'Appointment Accepted',
          'Appointment Rejected',
          'Appointment Tentative',
          'Appointment Canceled'
        ],
        'Document/Form Update': [
          'Form Submitted'
        ],
        'Report Update': [
          'Report Available',
          'Report Shared'
        ],
        'Task Update': [
          'Task Open',
          'Task Completed'
        ],
        'Internal Note Status Update': [
          'Internal Note Created',
          'Internal Note Update'
        ]
      };
      return defaultEventsMap[this.subtype] || [];
    },
    onDeleteClick() {
      this.$emit('delete');
    },
    onConfigureClick() {
      this.$emit('configure');
    }
  }
};
</script>

<style scoped>
.trigger-notification {
  border-radius: 8px;
  background: #FEF9E9;
  display: flex;
  align-items: center;
  gap: 8px;
}

.trigger-notification-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.trigger-notification-icon svg {
  width: 100%;
  height: 100%;
}

.trigger-notification-text {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #374957;
}

.trigger-configured-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.configured-message {
  display: flex;
  align-items: center;
  gap: 8px;
}

.configured-message-icon {
  width: 17px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.configured-message-icon svg {
  width: 100%;
  height: 100%;
}

.configured-message-text {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #374957;
}

.chips {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chips-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.chip {
  padding: 4px 12px;
  border-radius: 16px;
  background: #C4DCDF;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #333;
  white-space: nowrap;
}

.chip-more {
  padding: 4px 12px;
  border-radius: 16px;
  background: #F3F4F6;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #6B7280;
  white-space: nowrap;
}

</style>
